import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ResponseTranslation } from '../models/Translations';

interface LocalizedField {
  [langCode: string]: string;
}
@Pipe({
  name: 'localized',
  standalone: true,
  pure: false,
})
export class TranslateLocalizedPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: ResponseTranslation | null | undefined): string {
    if (!value) return '';
    const lang = this.translateService.currentLang || this.translateService.getDefaultLang();
    return (value as any)[lang] || (value as any)['en'] || '';
  }
}
